/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const blockTokens = {
  CoreBackgroundColorDefault: '#ffffff',
  CoreBackgroundColorTransparent: 'rgba(0, 0, 0, 0)',
  CoreBorderStyle: '1px solid #dedfdf',
  CoreBorderRadius: '4px',
  CoreSpacingBox: '32px',
  CoreIconColor: '#656b6b',
  CoreShadowFocus: '0px 0px 9px 0px #285da3',
} as const;
